"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiErrorBase = void 0;
class ApiErrorBase extends Error {
    constructor(code, message, canRetry) {
        super(message);
        this.errorMessage = message;
        this.errorCode = code;
        this.canRetry = canRetry;
    }
}
exports.ApiErrorBase = ApiErrorBase;
//# sourceMappingURL=ApiErrorBase.js.map